import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Owners_ds_get_material_count_by_owner_idService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { owner_id: number }): 
  Promise<{ result: { TotalMaterials?: number, Project?: { Owner?: { Id?: number } } } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.owner_id)) {
      missingRequiredInParams.push('\'owner_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Owners/datasources/ds_get_material_count_by_owner_id/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      owner_id: number    }) {
        if(isNil(inParams.owner_id)) {
          return true; 
        }
      return false;
    }
}
